import { debounce } from 'lodash/fp';
import { useEffect } from 'react';
import { defaultMemoize as memoizeOne } from 'reselect';

// global toggle for cookie hide/show. The cookie bar is only one, so global handler is sufficient and way simpler than
// React context. The handler is debounced, for the `useEffect` might fires show/hide in quick turns and we don't want
// our cookie banner to affect the DOM several times in second. There is also `memoizeOne` which guards the show/hide
// from running when the previous argument is the same as current - i.e. prevents calling the show when the banner is
// already visible and vice-versa.
const debouncedToggle = debounce(
	200,
	memoizeOne((show) => {
		window.skippay?.cookie?.[show ? `show` : `hide`]();
	})
);

/**
 * Manages the visibility of cookie banner.
 * @param {boolean} [keepHidden] - when 'true' forces the banner to not-show
 */
function useCookie(keepHidden) {
	useEffect(() => {
		debouncedToggle(!keepHidden);
		return () => debouncedToggle(keepHidden);
	}, []);
}

export default useCookie;
